import posthog from "posthog-js";

const token = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const host = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;

export const analyticsEnabled = Boolean(token && host);

if (analyticsEnabled) {
  posthog.init(token, {
    api_host: host,
    capture_pageview: "history_change",
    autocapture: true,
    person_profiles: "identified_only",
  });
  // exposed for debugging/verification only (public project token, no secrets)
  window.__loopPosthog = posthog;
}

export function track(event, properties = {}) {
  if (!analyticsEnabled) return;
  try {
    posthog.capture(event, properties);
  } catch (e) {
    /* analytics must never break the app */
  }
}

export function identifyUser(user, extra = {}) {
  if (!analyticsEnabled || !user?.user_id) return;
  try {
    posthog.identify(String(user.user_id), { email: user.email, name: user.name, ...extra });
  } catch (e) {}
}

export function resetAnalytics() {
  if (!analyticsEnabled) return;
  try {
    posthog.reset();
  } catch (e) {}
}

export default posthog;
